import AttachmentDocCompactView from './AttachmentDocCompactView';
import AttachmentImageCompactView from './AttachmentImageCompactView';
import { observer } from 'mobx-react';
import { onAttachmentViewStateIdChange } from 'owa-attachment-compact-view/lib/actions/internalActions';
import { AttachmentDragData, AttachmentFile } from 'owa-attachment-file-types';
import createAttachmentFileFromExistingMailboxAttachment from 'owa-attachment-file-types/lib/utils/createAttachmentFileFromExistingAttachment';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { AttachmentViewState } from 'owa-attachment-select-actions';
import Draggable from 'owa-dnd/lib/components/Draggable';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import { isFeatureEnabled } from 'owa-feature-flags';
import * as React from 'react';
import { touchHandler, ITouchHandlerParams } from 'owa-mail-touch-handler';

export interface AttachmentCompactProps {
    onPreviewClick: (ev: React.MouseEvent<unknown>) => void;
    attachmentViewState: AttachmentViewState;
    isImage: boolean;
    isShortDocView: boolean;
    attachmentViewStateId: string;
}

const styles = require('./AttachmentCompactView.scss');
const classNames = require('classnames/bind').bind(styles);

const DRAG_X_OFFSET = -12;
const DRAG_Y_OFFSET = 5;

@observer
export default class AttachmentCompactView extends React.Component<AttachmentCompactProps, any> {
    get touchHandler() {
        const touchHandlerParams: ITouchHandlerParams = {
            onClick: this.onClick,
        };
        return touchHandler(touchHandlerParams);
    }

    render() {
        const conditionalStyles = {
            attachmentImageView: this.props.isImage,
        };

        const attachmentModel = getAttachment(this.props.attachmentViewState.attachmentId);
        return (
            <div
                {...this.touchHandler}
                onClick={this.onClick}
                title={attachmentModel.model.Name}
                className={classNames(styles.attachmentView, conditionalStyles)}>
                <Draggable
                    canDrag={this.canDrag}
                    getDragData={this.getAttachmentDragData}
                    getDragPreview={this.getDragPreview}
                    xOffset={DRAG_X_OFFSET}
                    yOffset={DRAG_Y_OFFSET}>
                    {this.props.isImage ? (
                        <AttachmentImageCompactView
                            attachmentViewState={this.props.attachmentViewState}
                        />
                    ) : (
                        <AttachmentDocCompactView
                            attachmentViewState={this.props.attachmentViewState}
                            isShortDocView={this.props.isShortDocView}
                        />
                    )}
                </Draggable>
            </div>
        );
    }

    private onClick = (ev: React.MouseEvent<unknown>) => {
        onAttachmentViewStateIdChange(this.props.attachmentViewStateId);
        this.props.onPreviewClick(ev);
    };

    private canDrag = (): boolean => {
        return (
            !!getAttachment(this.props.attachmentViewState.attachmentId) &&
            isFeatureEnabled('doc-attachment-listViewDragDrop')
        );
    };

    private getAttachmentDragData = (): AttachmentDragData => {
        const attachment = getAttachment(this.props.attachmentViewState.attachmentId).model;
        const attachmentFile: AttachmentFile = createAttachmentFileFromExistingMailboxAttachment(
            attachment
        );

        const attachmentDragData: AttachmentDragData = {
            itemType: DraggableItemTypes.Attachment,
            attachmentFile: attachmentFile,
        };

        return attachmentDragData;
    };

    private getDragPreview = (): HTMLElement => {
        const elem = document.createElement('div');
        elem.className = styles.dragPreview;
        elem.innerText = getAttachment(this.props.attachmentViewState.attachmentId).model.Name;
        return elem;
    };
}
